import { CompanyStats } from '@/views/companies/interfaces';

export const COMPANY_STATS: Partial<CompanyStats> = {
  sessions: 14,
  creatives: {
    total: 200,
    totalExports: 500,
    topExports: [
      { Facebook: 100 },
      { Instagram: 50 },
      { Twitter: 30 },
      { LinkedIn: 20 },
      { Pinterest: 10 },
    ],
  },
};

export default COMPANY_STATS;
